import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row content" }
const _hoisted_3 = { class: "col-12 col-lg-7 offset-lg-2 cuscd-item cuscd-add-side" }
const _hoisted_4 = { class: "cuscd-item-inner" }
const _hoisted_5 = { class: "cuscd-section-divide" }

import Page from "@/components/shared/Page.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'OidcCallbackError',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "cuscd-h2style" }, "Authentication Error", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "cuscd-desc" }, "There was an error logging you into the Borrower Application.", -1)),
                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "btn btn-outline-secondary btn-sm cuscd-outline-cta"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" Try Logging In Again ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})